module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp23_8017.e550a1fa.png";